import React, {useState, useEffect} from 'react';
import  {Badge} from 'react-bootstrap';
import { PopoverInfo } from "../../../../partials/Partials";

function TableHeader(props) {
        const {active, pages, changeTable,unread, loading} = props
        let table_headers = [];

        if(pages)
        pages.map((item, i) => {
            table_headers.push(
                <TableTitle 
                    page={pages[i]} 
                    key={i} 
                    index={i} 
                    active={active} 
                    changeTable={changeTable}
                    unread={unread}
                    loading={loading}
                />
            )
            return table_headers
        })
        return <tr>{table_headers}</tr>
}

function TableTitle(props) {
    const {active, page, index, unread, loading} = props
    const [displayed_unread, setUnread] = useState(0);

    useEffect(()=>{
        if(!loading)
        setUnread(unread);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading])

    const clickedIndex = (event) => {
            setUnread(null);
            props.changeTable(props.index)
            event.preventDefault();
            
        }

    if(index === active && index !== 2) {
        return (
            <td className={`table-header ${(active === index) ? 'active-table-header' : 'pointer' }`} onClick={clickedIndex}>
                {page} 
                <Badge className=
                    "badge-circle grey">{displayed_unread}</Badge>
                <div className="btn btn-link info-icon">
                    <PopoverInfo title={page} text={index}/>
                </div>
            </td>
        )
    } else {
        return (
        <td className={`table-header ${(active === index) ? 'active-table-header' : 'pointer' }`} onClick={clickedIndex}>
            {page} 
            <div className="btn btn-link info-icon text-wrap">
                <PopoverInfo title={page} text={index}/>
            </div>
        </td>
        )
    }
}

export default TableHeader;